export default __webpack_public_path__ + "static/media/32.71154402.mp3";